import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { ServiceType } from '../types'
import { getServiceConfig } from '../data/services'

interface RouteGuardProps {
  serviceType: ServiceType
  children: React.ReactNode
}

export const RouteGuard: React.FC<RouteGuardProps> = ({ serviceType, children }) => {
  const location = useLocation()
  const service = getServiceConfig(serviceType)

  // If service is not active, redirect to main page with services section
  if (!service.isActive) {
    return <Navigate to="/#services" replace state={{ from: location }} />
  }

  // Service is active, render children
  return <>{children}</>
}

// Legacy route handler for backward compatibility
interface LegacyRouteHandlerProps {
  children: React.ReactNode
}

export const LegacyRouteHandler: React.FC<LegacyRouteHandlerProps> = ({ children }) => {
  const location = useLocation()
  
  // Handle legacy routes and redirects
  const handleLegacyRoute = () => {
    const path = location.pathname
    
    // Legacy HR template routes
    if (path.includes('/templates') || path.includes('/hiring')) {
      return '/hr'
    }
    
    // Legacy admin routes
    if (path.includes('/admin')) {
      return '/hr/admin'
    }
    
    // Legacy API routes should not be handled by frontend router
    if (path.startsWith('/api')) {
      return null // Let backend handle
    }
    
    return null
  }

  const redirectPath = handleLegacyRoute()
  
  if (redirectPath) {
    return <Navigate to={redirectPath} replace state={{ from: location }} />
  }

  return <>{children}</>
}